module.exports = __webpack_public_path__ + "static/img/bg3.0a3be0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg3.png
// module id = cZGn
// module chunks = 0